export default function customArraySort(columns) {
  /* eslint-disable func-names */
  const sorter = function (a, b) {
    const result = columns.map(column => {
      if (!a[column] || !b[column]) {
        return 0;
      }
      return a[column].localeCompare(b[column]);
    });
    let res = 0;
    result.forEach(element => {
      if (res === 0 && element !== 0) res = element;
    });
    return res;
  };
  /* eslint-enable func-names */

  return sorter;
}



// WEBPACK FOOTER //
// ./src/services/general/customArraySort.js